'use client';

import { type User } from '~/service/user';
import { toBase64 } from '~/utils/base64';
import { environment, version } from '~/utils/constants';

import { CopyAction } from './copy';
import BugIcon from '../icons/bug.svg';

export interface CopyDebugInfoProps {
  data: User['data'] | undefined;
}

export function CopyDebugInfoAction({ data }: CopyDebugInfoProps) {
  return (
    <CopyAction
      tooltip="Copy debug info"
      copyContent={toBase64(
        JSON.stringify({
          user: data || null,
          vars: {
            environment,
            version,
          },
        }),
      )}
    >
      <BugIcon />
    </CopyAction>
  );
}
